import mdsRequire from 'dojo/require';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './HintBox.html?raw';
import query from 'dojo/query';
import { SelectEntityDialogTypes, SelectEntityDialog } from "../../_loadingHelpers/SelectEntityDialog";
import { AccessibilityLabelsHelper, ColorHelpers, EntityHelpers } from "../../../more/Helpers";
import { TooltipConfig_Base } from "../Floating/FloatingTypes";
import Tooltip from '../Floating/Tooltip';

interface InlineButton {
    name: string,
        node: HTMLElement,
            callback: Function,
                iconNode: HTMLElement;
}
class HintBox extends compose(_LabelInputBase) {
    templateString: any = template;

    private dropdownContainer: HTMLElement;
    private actionContainer: HTMLElement;
    private itemlistContainer: HTMLElement;
    private inputRow: HTMLInputElement;
    private progressOverlay: HTMLInputElement;
    private inputContainer: HTMLInputElement;
    private inputNode: HTMLInputElement;
    private innerInputContainer: HTMLInputElement;
    private errorMsgNode: HTMLElement;
    private btnRevert: HTMLButtonElement;
    private btnEmpty: HTMLButtonElement;
    private btnClose: HTMLButtonElement;

    validationMsgNodeContainer = "errorMsgNode";

    enablePlainTextValue: boolean = false;
    valueIsPlaintext: boolean = false;
    private isOpened: boolean = false;
    private isInteraction: boolean = false;

    currentFocus: number = -1;

    labelAttribute: string = null;
    colorAttribute: string = null;
    secondaryLabelAttribute: string = null;
    valueAttribute: string = "ID";
    suggestionLabelAttribute: string = null;
    filterPath: string = null;
    searchParam: string = null; // name des Parameters im Filter ( => pit-Filter)
    requestUrlSearchParameter: string = "searchValue"; // name des Parameters der über die Url als Http-Request gesendet wird (=> Controller)
    jsonRequestParameterName: string = null;


    private _additionalRequestParameters: object = null; // name des zusätzlichen Parameters, um die Suche zu begrenzen

    //dataFormat: more.PitHelperStructureFormatType = more.PitHelperStructureFormatType.pit; // "pit" oder "json" // ist jetzt in controlbase!

    private __request: dojo.request.Promise<any>;
    private __lastRequestedSearchValue: string;
    private __searchDelay: number;

    private _plainvalue: string = null;

    private __requestParams: Object = {};
    private __maxResults: number = 500;

    resetOnEdit: boolean = false;
    private entities: Array<object>;
    private url: string = null;
    private callfunction: string = null;
    minLetterCount: number = 3;
    searchDelayTimeout: number = 666;
    //_value: object = null;

    private _previousValue: any = null;

    private _constructDefaultUrl() : string {
        return "Entity/GetFilterEntityListData" + '?filterPath=' + this.filterPath + '&searchParam=' + this.searchParam + '&jsonAttributeNames=["' + this.labelAttribute + '"]';
    }

    setInputNodeReadonly(readonly: boolean) {
        this.disableNode(this.inputNode, readonly);
    }

    focus() {
        this.inputNode.focus();
    }

    setUrl(newUrl: string) {
        if (newUrl !== null && newUrl !== "" && newUrl !== undefined) {
            this.callfunction = null;
        }

        this.url = newUrl;
    }
    setCallfunction(callfunctionName: string) {
        if (callfunctionName) {
            this.url = null;
        }

        this.callfunction = callfunctionName;
    }

    setLabelAttribute(newLabel: string, secondaryLabel?: string) {
        if (newLabel !== null && newLabel !== "" && newLabel !== undefined) {
            this.labelAttribute = newLabel;
        }

        if (secondaryLabel) this.secondaryLabelAttribute = secondaryLabel;
    }
    //private _setEnableSelectEntityDialogAttr(enable: boolean) {
    //

    //    this.enableSelectEntityDialog(enable);
    //}
    private _setUseSelectEntityDialogAttr(enable: boolean) {
        this.enableSelectEntityDialog(enable);
    }

    private _setSelectEntityDialogSearchBehaviourAttr(behav: string) {
        this._setSEDsearchBehaviourAttr(behav);
    }
    private _setSelectEntityDlgSearchBehaviourAttr(behav: string) {
        this._setSEDsearchBehaviourAttr(behav);
    }
    private _setSEDsearchBehaviourAttr(behav: string) {
        this.setSelectEntityDlgSearchBehaviour(behav as any);
    }

    setSelectEntityDlgSearchBehaviour(behav: "local" | "default") {
        this._sedSearchBehaviour = behav;
    }

    enableSelectEntityDialog(enable?: boolean, newButtonCallback?: Function) {
        //console.debug("_setEnableSelectEntityDialogAttr", this.id, this.domNode, this._label, enable);
        if (enable !== true && enable !== false) {
            enable = true;
        }

        if (this._sedButton) {
            this.removeInlineButton(this._sedButton.name);
            this._sedButton = null;
            this._sedNewCallback = null;
        }

        if (enable) {
            let btnReg = this.addInlineButton(lang.hitch(this, this._showSelectEntityDialog), this.id + "_SED");
            if (btnReg) {
                this._sedButton = btnReg;
                this.UiModder.domConstruct.place(this._sedButton.node, this.innerInputContainer, "last"); // SED immer nach hinten stellen!
                this._sedNewCallback = newButtonCallback;
                this.setDataCyAttribute(this._sedButton.node, "sedButton"); // E2E: <feld>:sedButton (Re-Stamp via setAllDataCyAttributes)
            }

        }


    }

    private _sedNewCallback: any = null;
    private _sedSearchBehaviour: "local" | "default" = "local";
    private _sedButton: InlineButton = null;
    private _isSedActive: boolean = false;

    private _showSelectEntityDialog() {

        this.cancelRequest();

        this.closeAllLists();
        this._isSedActive = true;


        let SelectEntityDialogClass: any = mdsRequire("moreCore/UI/SelectEntityDialog/SelectEntityDialog");
        let dlg = (new SelectEntityDialogClass()) as MdsLax<InstanceType<typeof SelectEntityDialog<any>>>;
        dlg.setConfiguration({
            enableSelectNone: false,
            entriesPerPage: 10,
            requestUrl: this.url,
            callfunction: this.callfunction,
            title: this.getLabel(),
            trees: null,
            labelAttribute: this.labelAttribute,
            valueAttribute: this.valueAttribute,
            colorAttribute: this.colorAttribute
        }, lang.hitch(this, this._onSelectEntityDialogResult, dlg), this._sedNewCallback);

        dlg.on("close", lang.hitch(this, this._onSEDclosed));

        if (this.jsonRequestParameterName) {
            dlg.setGlobalRequestParameterName(this.jsonRequestParameterName);
        } else if (this.requestUrlSearchParameter) {
            dlg.setGlobalRequestParameterName(this.requestUrlSearchParameter,)
        }

        if (this._additionalRequestParameters) {
            dlg.addRequestParameter("additionalParameters", this._additionalRequestParameters, true);

            for (let key in this._additionalRequestParameters) {
                dlg.addRequestParameter(key, this._additionalRequestParameters[key], true);
            }
        }

        if (this.__requestParams) {
            for (let key in this.__requestParams) {
                dlg.addRequestParameter(key, this.__requestParams[key], true);
            }
        }
        let searchValue = this.inputNode.value && this.isInteraction ? this.inputNode.value : null;
        dlg.show(searchValue, this._sedSearchBehaviour == "local" ? true : false);

    }
    private _onSEDclosed() {
        this._isSedActive = false;
    }
    private _onSelectEntityDialogResult<T>(dlg: MdsLax<InstanceType<typeof SelectEntityDialog<T>>>, results: Array<string>, items: Array<SelectEntityDialogTypes.Item<T>>) {
        this._isSedActive = false;
        if (items && items.length) {
            let entity = dlg.getSelectedEntities()[0];
            if (typeof (entity) == "undefined") {
                // dann ist es ein packed result, ohne entitydata? (also nur item bestehend aus label und value)
                entity = {

                } as any;
                entity[this.valueAttribute] = items[0].entry.value;
                entity[this.labelAttribute] = items[0].entry.label;
            }
            this.setValue(entity as any);
        }
    }

    private inlineButtons: Array<InlineButton> = [];

    private getInlineButtonIndexByName(name: string): number {
        if (!name) return -1;
        let i = 0;
        for (let button of this.inlineButtons) {
            if (button.name == name) {
                return i;
            }

            i++;
        }

        return -1;
    }

    removeInlineButton(name: string) {
        let existing = this.getInlineButtonIndexByName(name);
        if (existing >= 0) {
            this.UiModder.domConstruct.destroy(this.inlineButtons[existing].node);
            this.inlineButtons.splice(existing, 1);
        }

        this.hideNode(this.innerInputContainer, this.inlineButtons.length == 0);
        this.progressOverlay.style.setProperty("--rightPadding","0px");
    }

    disableInlineButton(name: string, disable = true) {
        let existing = this.getInlineButtonIndexByName(name);
        if (existing >= 0) {
            disable ? this.UiModder.domClass.add(this.inlineButtons[existing].node, "disabled") : this.UiModder.domClass.remove(this.inlineButtons[existing].node, "disabled");
        }
    }

    private recalcOverlaySize() {
        this.progressOverlay.style.setProperty("--rightPadding", this.innerInputContainer.clientWidth.toString() + "px");
    }

    getInlineButtonByName(name: string): InlineButton {
        let index = this.getInlineButtonIndexByName(name);

        if (index != -1) return this.inlineButtons[index];

        return null;
    }

    addInlineButton(callback: Function, name?: string, iconClass: string = "fas fa-share-square", label?: string, tooltipConfig?: TooltipConfig_Base): InlineButton {
        if (!callback) return;

        if (!iconClass && !label) return;

        if (!name) {
            name = "hib-" + (Math.random() * 100000).toFixed(0);
        }
        else {
            this.removeInlineButton(name);
        }

        let existingButton = this.getInlineButtonByName(name);
        if (existingButton) return;

        let button = this.UiModder.domConstruct.create("button", {
            "className": "mds-button-base hoverDark round mediumTransparent hintboxInlinebutton",
            innerHTML: label ? label : "",
            id: name
        }, this.innerInputContainer, "first");

        let buttonReg: InlineButton = {
            callback: callback,
            node: button,
            name: name,
            iconNode: null
        };

        this.inlineButtons.push(buttonReg);

        if (iconClass) {
            let icon = this.createFontawesomeIcon(iconClass, label ? "&nbsp;" : "");
            this.UiModder.domConstruct.place(icon, button, "first");

            buttonReg.iconNode = icon;
        }

        on(button, "click", callback);

        this.hideNode(this.innerInputContainer, this.inlineButtons.length == 0);

        this.setReadonly(this.isReadonly);

        if (tooltipConfig) {
            let tooltip = new Tooltip();

            tooltip.setup({
                targetnode: button,
                ...tooltipConfig
            })
        }

        return buttonReg;
    }


    /**
     * Gibt den Wert zurück, je nach gewähltem modus-Parameter (Standrdverhalten ist: entity wenn ausgefüllt, plaintext wenn entity leer und plaintext ausgefüllt )
     * @param mode value gibt den Entity-Wert (üblicherweise ID) oder Plaintextwert zurück; entity gibt das gewählte Objekt zurück oder null falls nicht ausgefüllt; plaintext gibt immer den reinen Text- bzw. Anzeigewert zurück.
     */
    getValue(mode?: "entity" | "value" | "plaintext"): any {
        if (mode === "value") {
            // falls kein entity, aber Plaintext: Textwerte zurückgeben
            if (this.enablePlainTextValue && typeof(this._value) == "string") {
                return this._plainvalue;
            }

            // ansonsten Value von Entity
            return this.PitHelper.getEntityAttributeValue(this._value, this.valueAttribute, this.dataFormat);
        } else if (mode === "plaintext") {
            return this._plainvalue;
        }

        if (this.enablePlainTextValue && typeof( this._value ) == "string") {
            if (mode != "entity") {
                return this._plainvalue;
            } else {
                return null;
            }
        }

        return this._value;
    }


    setReadonly(readonly: boolean = true) {
        super.setReadonly.apply(this, arguments as any);

        this.UiModder.domClass.toggle(this.domNode, "w3-disabled", this.isReadonly);
        this.closeAllLists();
        if (this.__request && this.isReadonly) {
            this.cancelRequest();
        }

        if (this._sedButton?.node) this.disableNode(this._sedButton?.node, this.isReadonly);
        this.disableNode(this.innerInputContainer, this.isReadonly);
    }

    _getValueAttr(mode?: "entity" | "value" | "plaintext"): object {
        return this.getValue(mode);
    }

    _setValueAttributeAttr(attributename: string) {
        this.valueAttribute = attributename;
    }

    _setValueAttr(value: object): void {
        var callChange = false;
        if (this._value != value) {
            callChange = true;
        }

        this.setValue(value, !callChange);
    }

    _setMaxResultsCountAttr(value: number): void {
        this.setMaxResultsCount(value);
    }

    setMaxResultsCount(value: number): void {
        if (value == null || value < 0) {
            value = 50; // default
        }
        this.__maxResults = value;
    }
    /**
     * Ergebnisliste wird aufgrund dieser Regeln mit Styleklassen versehen
     * @param propertyName Name des Propertys, das zu prüfen ist
     * @param propertyValue Erwarteter Wert
     * @param formatToApply Styleklasse, die in der Ergebnisliste angewandt wird
     */
    addConditionalFormat(propertyName: string, propertyValue: any, formatToApply: string) {
        this._formatRules.push({
            property: propertyName,
            value: propertyValue,
            format: formatToApply
        });
    }

    private _formatRules: Array<{ property: string, value: any, format: string }>;

    setPlainValue(newValue: string, bSuppressChange?: boolean, forceIfDisabled?: boolean): void {
        this._plainvalue = newValue;
        this.set("value", this._plainvalue);
        this.setValue(newValue, bSuppressChange, forceIfDisabled);
    }

    setValue(newValue: object | string, bSuppressChange?: boolean, forceIfDisabled?: boolean): void {

        this.isInteraction = false;

        //console.log("selectbox newValue", newValue, delimiter);
        let oldPlainValue = this.getValue("value");

        if (this.isOpened) {
            this.closeAllLists();
        }

        let isPlaintextValueOnly: boolean = false;

        let newPlainValue: string = null;


        if (newValue == null) {
            newPlainValue = null;
            this.valueIsPlaintext = false;
        }
        else if (typeof (newValue) == "object") {
            newPlainValue = this.PitHelper.getEntityAttributeValue(newValue, this.valueAttribute, this.dataFormat);
            isPlaintextValueOnly = false;
            this.valueIsPlaintext = false;

        } else if (typeof (newValue) == "string" && this.enablePlainTextValue){ //LH nur wenn plaintext auch erlaubt ist!
            newPlainValue = newValue;
            isPlaintextValueOnly = true;
            this.valueIsPlaintext = true;
        }

        // hat sich was geändert?
        if (oldPlainValue && oldPlainValue == newPlainValue) {
            return;
        }


        this._value = newValue;

        this.UiModder.domClass.toggle(this.domNode, "plaintextValue", isPlaintextValueOnly);

        let colorValueBG: string = null;
        let colorValueTXT: string = null;
        let colorValueUnknown = null;


        if (newValue == null) {
            this.inputNode.value = "";
            if (this._plainvalue != null) {
                if (this.resetOnEdit == true) {
                    this.inputNode.value = null; // dann wird halt auch beim Eintippen (Reset) sofort alles gelöscht, blöd; allerdings weiß der Benutzer dann dass Entity leer
                }
            }
            this._plainvalue = newPlainValue;
        } else if (typeof (newValue) == "object" ){
            this.inputNode.value = this.PitHelper.getEntityAttributeValue(this._value, this.labelAttribute, this.dataFormat);
            this._plainvalue = this.inputNode.value;

            if (this.colorAttribute) {
                colorValueUnknown = EntityHelpers.getComplexProperty(newValue, this.colorAttribute);
                if (colorValueUnknown) {
                    colorValueBG = ColorHelpers.getHexColorFromProperty(colorValueUnknown, "BG");
                    colorValueTXT = ColorHelpers.getHexColorFromProperty(colorValueUnknown, "TXT");
                }

                this.inputContainer.style.setProperty("--bgColor", colorValueBG);
                this.inputContainer.style.setProperty("--txtColor", colorValueTXT);
            }


        } else {
            this.inputNode.value = newPlainValue;
            this._plainvalue = newValue;
        }


        this.validateInput();

        if (bSuppressChange === true) { }
        else {
            this.emitChangeEvent();
        }

    }

    private _loadListValues(searchText: string): void {
        if (this._isSedActive) return;

        this.recalcOverlaySize();
        if (this._value) {

            this._previousValue = this._value;
        }
        //  bei jeder Textänderung erstmal das selectedEntity entfernen
        //
        this._value = null;
        this.validateInput();

        if (searchText == null) {
            return;
        }
        if (searchText.length < this.minLetterCount) {
            return;
        }

        if (this.itemlistContainer) {
            this.UiModder.domClass.add(this.itemlistContainer, "disabled");
        }

        let requestParams = this.prepareRequestParams();

        if (this._additionalRequestParameters) {

            let paramsObj = this.getAdditionalRequestParams(true) as Object;

            if (this.jsonRequestParameterName) {
                // die zusätzlichen Properties auch direkt als Properties einfügen, sonst ist es in den APIs immer so ein Suchspiel warum was nicht geht.
                if (paramsObj) {
                    for (let key in paramsObj) {
                        requestParams[this.jsonRequestParameterName][key] = paramsObj[key];
                    }
                }

            } else {
                requestParams["additionalParameters"] = this.getAdditionalRequestParams();

                // die zusätzlichen Properties auch direkt als Properties einfügen, sonst ist es in den APIs immer so ein Suchspiel warum was nicht geht.
                if (paramsObj) {
                    for (let key in paramsObj) {
                        requestParams[key] = paramsObj[key];
                    }
                }
            }
        }

        if (this.jsonRequestParameterName) {
            requestParams[this.jsonRequestParameterName][this.requestUrlSearchParameter] = searchText;

            requestParams[this.jsonRequestParameterName] = JSON.stringify(requestParams[this.jsonRequestParameterName]);
        } else {
            requestParams[this.requestUrlSearchParameter] = searchText;
        }


        this.cancelRequest();


        if (this.callfunction) {
            this.StandbyStart();

            this.__lastRequestedSearchValue = searchText;
            this.__request = this.RequestManager.callfunction(this.callfunction,
                requestParams,
                lang.hitch(this, this._onLoadListValuesResponse),
                lang.hitch(this, this._onLoadListValuesError)
            );

        } else {
            let url;
            if (this.url == null) {
                let error = this.id + ": no url or function provided to execute search with!";
                this._onLoadListValuesError({ Message: error });
                return;
            } else {
                url = this.url;
            }

            // in case of GET
            let requestUrl = window.appRoot + url; //+ sFirstParamDelmiter + this.requestUrlSearchParameter + '=' + searchText;
            //console.debug("hintbox loadvalues", requestParams);

            this.StandbyStart();

            this.__lastRequestedSearchValue = searchText;
            this.__request = this.RequestManager.post(
                requestUrl, //@TODO: alles was der SelectEntityButton kann auch hier als parameter mitgeben
                requestParams,
                lang.hitch(this, this._onLoadListValuesResponse),
                lang.hitch(this, this._onLoadListValuesError)
            );
        }
    }

    private _onLoadListValuesError(err: Partial<more.requestErrorMessage>) { // errorCallback

        this.__request = null;
        alert(err.Message);

        this.StandbyStop();
    }

    private _onLoadListValuesResponse(response: any) {
        //debugger
        this.__request = null;
        this.StandbyStop();

        let entitiesArray: Array<object> = [];

        if (this.dataFormat == "pit") {
            entitiesArray = response.EntityDataArray;
        } else {
            if (typeof (response) == "object" && response != null) {
                if (lang.isArray(response)) {
                    // Array als Antwort
                    entitiesArray = response;
                } else if (response.entitylist && typeof (response.totalResultCount) == "number") {
                    entitiesArray = (response as more.PackedEntitylistResult<any>).entitylist;
                }
            }

        }

        // wenn das response ist [], dann wird input.value in plaintext hergenommen
        if (this.enablePlainTextValue === true && !entitiesArray.length) {
            //this._value = this.inputNode.value;
            this._plainvalue = this.inputNode.value;
            this.set("value", this._plainvalue);
            this.setValue(this._plainvalue, false);
            this.closeAllLists();
            this.validateInput();
            this.UiModder.domClass.add(this.domNode, "plaintextValue"); //LH Wenn kein Ergebnis gefunden && plainText erlaub dann auch umschalten auf Plaintext
            return;
        }

        if (entitiesArray.length > this.__maxResults) {
            entitiesArray.length = this.__maxResults;
        }

        this.entities = entitiesArray;

        this._handleResults(); // eigentliche suche mit Textvergleich im Javascript der mit den zurückgelieferten Entities arbeitet
    }

    // in case of GET
    //addRequestParams(url: string): string {

    //    let obj = this.requestUrl_additionalSearchParameter;

    //    if (JSON.stringify(obj) !== '{}') {
    //        for (let key in obj) {
    //            url += '&' + `${key}` + '=' + `${obj[key]}`;
    //        }
    //    }

    //    return url
    //}

    private _handleResults(): boolean {

        let a, itemSelector: HTMLElement, i, val = this.inputNode.value;

        if (!val) { return false; }

        //val = val.replaceAll("%", "");

        this.currentFocus = -1;

        //  Container für Vorschläge
        //
        this.UiModder.domConstruct.empty(this.itemlistContainer);
        this.UiModder.domClass.remove(this.itemlistContainer, "disabled");

        this.hideNode(this.dropdownContainer, false);
        this.isOpened = true;
        this.UiModder.domClass.toggle(this.btnRevert, "w3-hide", this._previousValue == null);
        this.UiModder.domClass.toggle(this.btnEmpty, "w3-hide", this._previousValue == null);
        this.UiModder.domClass.toggle(this.btnClose, "w3-hide", this._previousValue != null);

        if (this.entities.length) {
            for (i = 0; i < this.entities.length; i++) {
                let entity = this.entities[i];

                let itemLabel = this.PitHelper.getEntityAttributeValue(entity, this.labelAttribute, this.dataFormat);
                if (this.suggestionLabelAttribute) {
                    itemLabel = this.PitHelper.getEntityAttributeValue(entity, this.suggestionLabelAttribute, this.dataFormat);
                }

                //  Textvergleich der geladenen Items mit eingegebenem String
                //
                let searchtermStartIndex = itemLabel.toUpperCase().indexOf(val.toUpperCase());
                // für alle gefundenen Items ein Element im Vorschlagscontainer erstellen
                //
                itemSelector = document.createElement("DIV");
                this.UiModder.domClass.add(itemSelector, "item hoverDark");

                // bedingte Formatierungen!
                for (let rule of this._formatRules) {
                    if (rule.property) {
                        for (let property in entity) {
                            if (property == rule.property) {
                                let value = entity[rule.property];
                                if (value == rule.value) {
                                    this.UiModder.domClass.add(itemSelector, rule.format);
                                }
                            }
                        }
                    }
                }

                if (searchtermStartIndex > -1) {

                    if (this.entities.length == 1) {
                        this.UiModder.domClass.add(itemSelector, "hintbox-active");
                        this.currentFocus = 0;
                    }
                    //  markieren der Textübereinstummengen
                    //
                    let leftPart = itemLabel.substr(0, searchtermStartIndex);
                    let midPart = "<strong>" + itemLabel.substr(searchtermStartIndex, val.length) + "</strong>";
                    let rightPart = itemLabel.substr(searchtermStartIndex + val.length);
                    this.UiModder.domConstruct.create("div", {
                        class: "label",
                        innerHTML: leftPart + midPart + rightPart
                    }, itemSelector);
                    //itemSelector.innerHTML += leftPart + midPart + rightPart;

                    if (this.secondaryLabelAttribute) {
                        let value = this.PitHelper.getEntityAttributeValue(entity, this.secondaryLabelAttribute, this.dataFormat);
                        if (value) {
                            value = this.stringReplaceAll(value, "\n", "<br>");
                            let secondaryLabel = this.UiModder.domConstruct.create("div", {
                                innerHTML: value ? value : "",
                                class: "secondaryLabel w3-tiny"
                            }, itemSelector);
                        }
                    }

                    if (this.colorAttribute) {
                        let value = EntityHelpers.getComplexProperty(entity, this.colorAttribute);
                        if (value) {
                            let colorBG = ColorHelpers.getHexColorFromProperty(value, "BG");
                            let colorTXT = ColorHelpers.getHexColorFromProperty(value, "TXT");

                            itemSelector.style.setProperty("--bgColor", colorBG);
                            itemSelector.style.setProperty("--txtColor", colorTXT);

                            itemSelector.classList.add("colored");
                        }
                    }
                    var tmpEle = document.createElement("input");
                    tmpEle.type = "hidden";
                    tmpEle.value = JSON.stringify(entity);

                    itemSelector.innerHTML += tmpEle.outerHTML;
                } else {
                    var tmpEle = document.createElement("input");
                    tmpEle.type = "hidden";
                    tmpEle.value = JSON.stringify(entity);

                    this.UiModder.domAttr.set(itemSelector, "innerHTML", itemLabel + tmpEle.outerHTML);
                }

                itemSelector.addEventListener("click", lang.hitch(this, function (listElement, e) {
                    let tmpInput = query("input", listElement)[0];
                    let jsonEntity = this.UiModder.domAttr.get(tmpInput, "value");
                    this.set("value", JSON.parse(jsonEntity));

                    this.closeAllLists();

                }, itemSelector));
                this.itemlistContainer.appendChild(itemSelector);
            }

            this.actionContainer.scrollIntoView({ behavior: "smooth", block: "nearest" });

        } else {
            let emptyEntry = this.UiModder.domConstruct.create("DIV", {
                className: "w3-disabled italic paddingSmall",
                innerHTML: this.translate("General__NoEntries")
            }, this.itemlistContainer);

            on(emptyEntry, "click", lang.hitch(this, this.closeAllLists));
        }
    }

    setEnablePlaintextValue(enable: boolean = true) {
        this._setEnablePlainTextValueAttr(enable);
    }
    private _setEnablePlainTextValueAttr(bool: boolean): void {
        this.enablePlainTextValue = bool;
    }
    // einige Aliase:
    private _setPlainTextAttr(bool: boolean) {
        this._setEnablePlainTextValueAttr(bool);
    }
    private _setPlaintextAttr(bool: boolean) {
        this._setEnablePlainTextValueAttr(bool);
    }private _setPlaintextValueAttr(bool: boolean) {
        this._setEnablePlainTextValueAttr(bool);
    }
    private _setEnablePlaintextAttr(bool: boolean) {
        this._setEnablePlaintextAttr(bool);
    }
    //


    private _setupEventListener(): void {

        //  "input" klappt im dojo-template nicht?!?!
        //
        this.inputNode.addEventListener("input", lang.hitch(this, "_onInput"));

        on(this.inputNode, "click", lang.hitch(this, this._onClick_Input));

        //  click irgendwo im dokument schließt die vorschläge
        //
        //document.addEventListener("click", lang.hitch(this, this._onDocument_Click));
        this.addSubscription("/Global/CloseModalMenus", lang.hitch(this, this._onDocument_Click));
        this.addSubscription("/Global/Click", lang.hitch(this, this._onDocument_Click));
    }

    private _onDocument_Click(evt: MouseEvent): void {
        if (this.isOpened) {
            this.setValue(this._previousValue);
        }
        this.closeAllLists(evt?.target as HTMLElement);
    }

    private _onClick_Input(evt: MouseEvent): void {
        if (this.isOpened) {
            evt.stopPropagation();
        }
        else {
            this._previousValue = this._value;
        }
    }

    private _onInput(evt: KeyboardEvent): void {
        if (this.__searchDelay != null) {
            clearTimeout(this.__searchDelay);
        }
        if (this._isSedActive) return;

        // Hinweis: hier kommen wir nicht hin, wenn der User "Enter" oder andere Steuertasten drückt, die keine sichtbare Änderung im Input hinterlassen

        if (this._plainvalue != this.inputNode.value && this._plainvalue != null) {
            this.emit("inputEdit", this.inputNode.value);
            //this._plainvalue = null;

            if (this.resetOnEdit === true) {
                this.set("value", this.inputNode.value);
            }
        }

        this.__searchDelay = setTimeout(lang.hitch(this, this._loadListValues, this.inputNode.value), this.searchDelayTimeout);
    }

    private _onKeyDown_Input(evt: KeyboardEvent): void {
        let hintboxElements: Array<HTMLElement> = null;
        this.isInteraction = true;
        let char = null;

        if (this.isReadonly) return;
        if (this._destroyed) return;


        if (this.itemlistContainer) hintboxElements = this.itemlistContainer.getElementsByClassName("item") as any as Array<HTMLElement>;
        //console.debug(this.id + " keydown", hintboxElements, evt.key);

        if (evt.key) {
            if (evt.key === "Tab") {
                // neue Eingabe, noch kein Wert, keine Suche laufend
                if (!this.__request && !this._value && this.inputNode.value) {
                    if (this.inputNode.value == this.__lastRequestedSearchValue) {

                        if (evt) evt.preventDefault();

                        if (this.currentFocus == -1) {
                            this.focusNextHintboxItem(hintboxElements);

                            return;
                        }
                        //  focus auf item gesetzt -> auswählen, als wäre es Enter
                        //
                        try {
                            if (hintboxElements && hintboxElements.length) {

                                if (hintboxElements.length > 1) {
                                    this.focusNextHintboxItem(hintboxElements);
                                    return;
                                } else {
                                    // einzelnes, also eindeutiges Ergebnis
                                    hintboxElements[this.currentFocus]?.click();
                                    this.inputNode.blur();
                                    return;
                                }
                            }
                        } catch (ex) {

                        }
                    } else {
                        // ==> Tab führt zu Start der Suche anstatt zu Raustabben
                        evt.preventDefault();

                        if (this._sedButton) {
                            this._showSelectEntityDialog();
                            return;
                        }

                        this._loadListValues(this.inputNode.value);
                        return;
                    }

                }
            }
            if (evt.key === "Escape") {
                evt.stopPropagation();
            }
            if (evt.key === "Backspace") { // backspace oder escape
                this.cancelRequest();
                if (this.resetOnEdit == true && this._value != null) {
                    this.setValue(null);
                }
            }
            if (evt.key.length == 1) {
                char = evt.key;

                if (this.resetOnEdit == true && this._value != null) {
                    if (this._value) {
                        this._previousValue = this._value;
                    }
                    this.setValue(null);
                    //this.inputNode.value = evt.key;
                }

                this.cancelRequest();
            }
            if (evt.key == "ArrowDown") {
                this.focusNextHintboxItem(hintboxElements);
            } else if (evt.key == "ArrowUp") { //up
                this.focusNextHintboxItem(hintboxElements, -1);
            } else if (evt.key == "Enter") { // enter
                evt.preventDefault();

                // falls Plaintext erlaubt ist und die Suche noch läuft: Enter führt zu Abbruch der Suche und Übernehmen des Werts
                if (this.__request && this.enablePlainTextValue) {
                    this.cancelRequest();
                    this.currentFocus = -1;
                }
                if (this.currentFocus > -1) {
                    //  focus auf item gesetzt
                    //
                    if (hintboxElements) {
                        hintboxElements[this.currentFocus]?.click();
                        this.inputNode.blur();
                    }
                } else {
                    //  kein focus auf item
                    //
                    let element = null;
                    if (hintboxElements) {
                        if (hintboxElements.length == 1) {
                            element = hintboxElements[0];
                            element.click();
                            this.inputNode.blur();
                        }
                    }

                    if (!element && this.enablePlainTextValue) {

                        if (this.__searchDelay) {
                            clearTimeout(this.__searchDelay);
                            this.__searchDelay = null;
                        }

                        this.closeList();
                        this.setValue(this.inputNode.value);
                        this.inputNode.blur();
                    }
                }
            } else if (evt.key == "Escape") { //esc
                this.setValue(this._previousValue);
                //this.closeList();
            } else {
                this.closeList();
            }
        }

    }
    private cancelRequest() {
        if (this.__request) {
            this.__request.cancel();
            this.__request = null;
        }
        if (this.searchDelayTimeout) {
            clearTimeout(this.searchDelayTimeout);
        }
        this.StandbyStop();
    }
    private _onFocus_Input(evt: Event) {
        if (this.isReadonly) return;
        this.isFocused = true;
    }
    private _onBlur_Input(evt: Event) {
        if (this.isReadonly) return;
        this.isFocused = false;
    //    if (this.__request) {

    //    } else {
    //        if (!this.isValid) this.inputNode.value = "";
    //    }
    }

    private _onChange_Input(evt: Event): void {
        if (this.inputNode.value.length == 0) {
            this.set("value", null);
        } else {

        }
//        this.emit("valueChange");
        this.validateInput();
    }

    private focusNextHintboxItem(hintboxItems, step?: number): boolean {
        if (!hintboxItems) return false;
        this.removeFocusFromItems(hintboxItems);

        if (typeof (step) == "number") {
            this.currentFocus = this.currentFocus + step;
        } else {
            this.currentFocus++;
        }

        if (this.currentFocus >= hintboxItems.length) this.currentFocus = 0;
        if (this.currentFocus < 0) this.currentFocus = (hintboxItems.length - 1);
        let item = hintboxItems[this.currentFocus];
        if (!item) return;

        this.UiModder.domClass.add(item, "hintbox-active");
        item.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    private removeFocusFromItems(hintboxItems): void {
        for (var i = 0; i < hintboxItems.length; i++) {
            this.UiModder.domClass.remove(hintboxItems[i], "hintbox-active");
        }
    }
    closeList(): void {
        //this.closeAllLists();
        this.hideNode(this.dropdownContainer);
        this.isOpened = false;

        this.UiModder.domConstruct.empty(this.itemlistContainer);
    }
    private closeAllLists(elmnt?: HTMLElement): void {
        //var x = query(".hintbox-items", this.domNode);
        //for (var i = 0; i < x.length; i++) {
        //    if (elmnt != x[i] && elmnt != this.inputNode) {
        //        x[i].parentNode.removeChild(x[i]);
        //    }
        //}

        this.closeList();
    }

    protected setInputValue(value:string): void {
        this.inputNode.value = value;
    }

    // Label --------------------------------------- Start


    // Label -----------------------------------------End

    // Validation --------------------------------------START

    protected customValidation(): boolean {
        let result = true;
        let data = this.getValue();

        //console.debug("hintbox validation - data - mandatory", data, this.isMandatory, this.validationEnabled);

        if (this.isMandatory && (data == undefined || data == "" || data == null)) {

            //this.validationErrorMsgText = window.translations['Generic__mandatory'];
            result = false;
        }

        if (typeof (this._value) == "string" && this.enablePlainTextValue != true) {
            result = false;
        }

        return result;
    }

    // Validation --------------------------------------END

    // SearchParam Getter und Setter ------------------------START

    addRequestProperty(name: string, value: any): void {
        let obj = this.__requestParams;

        obj[name] = value;
    }

    emptyRequestParams(): void {
        this.__requestParams = {};
        this.emptyAdditionalRequestParams();
    }

    removeRequestParams(): void {
        this.emptyRequestParams();
    }

    /**
     * Fügt dem Request ein Objekt "additionalParameters" ein, das aus den hier eingefügten Properties besteht.
     * @param param Name des Parameters
     * @param value Wert des Parameters
     */
    addAdditionalRequestParameter(param: string, value: any): void {
        if (!this._additionalRequestParameters) {
            this._additionalRequestParameters = {};
        }

        this._additionalRequestParameters[param] = value;
    }
    /**
     * Stellt einen Parameternamen ein, über den sämtliche Properties gebündelt als JSON abgeschickt werden (inklusive sonstige eingestellte Requestparameter), anstelle von separaten Requestparametern.
     * @param parameterName
     */
    setJsonRequestFormat(parameterName: string = "jsonData") {
        this.jsonRequestParameterName = parameterName;
    }


    private prepareRequestParams(): Object {
        let paramObj = {};
        let obj = this.__requestParams;

        if (this.jsonRequestParameterName) {
            paramObj[this.jsonRequestParameterName] = {};
            for (let property in obj) {
                paramObj[this.jsonRequestParameterName][property.toString()] = obj[property];
            }
        } else {

            for (let property in obj) {
                if (typeof (obj[property]) == "object") {
                    paramObj[property.toString()] = JSON.stringify(obj[property]);
                }
                else {
                    paramObj[property.toString()] = obj[property];
                }
            }
        }
        //console.debug("hintbox prepareRequestParams", paramObj);
        return paramObj;
        //return JSON.stringify(this.requestUrl_additionalSearchParameter);
    }

    getAdditionalRequestParams(getAsObject?: boolean): string | Object {
        if (getAsObject === true) {
            return this._additionalRequestParameters;
        }
        return JSON.stringify(this._additionalRequestParameters);
    }

    removeAdditionalRequestParam(paramKey: string, paramValue?: string): void {

        if (!this._additionalRequestParameters) return;

        let newParams: object = {};

        for (let property in this._additionalRequestParameters) {
            if (property == paramKey) {

            } else {
                newParams[property] = this._additionalRequestParameters[property];
            }
        }
        this._additionalRequestParameters = newParams;
    }

    emptyAdditionalRequestParams(): void {

        this._additionalRequestParameters = [];

    }

    _setPlaceholderAttr(placeholder: string): void {

        if (placeholder) {
            this.UiModder.domAttr.set(this.inputNode, "placeholder", placeholder);
        } else {
            this.UiModder.domAttr.remove(this.inputNode, "placeholder");
        }

    }

    private _recalculateInnerPadding() {
        this.domNode.style.setProperty("--inputPaddingRight", this.innerInputContainer.offsetWidth + "px");
    }

    // SearchParam Getter und Setter ------------------------END

    getDocumentationContent(): string {
        return "";
    }

    private _onClick_CloseList(evt: MouseEvent) {
        this.setValue(this._previousValue, true);
        //this.closeAllLists();
    }

    private _onClick_Empty(evt: MouseEvent) {
        this.setValue(null);
        this._previousValue = null;
    }

    _onClick_Revert(evt: MouseEvent) {
        if (this._previousValue) {
            this.setValue(this._previousValue);
            this._previousValue = null;
        }
    }

    private _standbyTarget: any = null;
    StandbyStart(node?: HTMLElement, stepName?: string, stepLabel?: string, stepCallback?: Function, groupName?: string): dijit._WidgetBase {
        this.UiModder.domClass.add(node ? node : this.progressOverlay, "ego_animated_progressBar");
        if (node) {
            this._standbyTarget = node;
        }
         // inherited für Standbymanager?? blöd...

        if (window.standbyManager) {
            window.standbyManager.addSpinner();
        }

        return null;
    }

    StandbyStop() {
        this.UiModder.domClass.remove(this._standbyTarget ? this._standbyTarget : this.progressOverlay, "ego_animated_progressBar");

        if (window.standbyManager) {
            window.standbyManager.removeSpinner();
        }
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._setupEventListener();
        this.validateInput();

        this._formatRules = [];
        this.inlineButtons = [];

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.inputNode, "hintboxInput", this.labelNode);
    }

    public setAllDataCyAttributes() {
        super.setAllDataCyAttributes.apply(this, arguments as any);
        this.setDataCyAttribute(this.btnEmpty, "btnEmpty");
        this.setDataCyAttribute(this.btnRevert, "btnRevert");
        this.setDataCyAttribute(this.btnClose, "btnClose");
        // E2E: SED-Inline-Button (öffnet den SelectEntityDialog) mitstampen, sofern vorhanden.
        if (this._sedButton?.node) this.setDataCyAttribute(this._sedButton.node, "sedButton");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.__requestParams = {};
    }
}

export default mdsWidget(HintBox);
